import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import authReducers from './reducers/authReducers';

import {
  safetyDashboardReducer,
  healthDashboardReducer,
  performanceDashboardReducer,
  securityDashboardReducer,
  dashboardReducer,
} from './reducers/dashboardReducers';

import { healthReducers } from './reducers/healthReducers';
import { outdoorReducers } from './reducers/outdoorReducers';
import { ProjectReducer, BuildingReducer, FloorReducer } from './reducers/dataReducers';
import { modeReducer } from './reducers/modeReducers';
import { performanceReducers } from './reducers/performanceReducers';
import { securityReducers } from './reducers/securityReducers';
import adminReducers from './reducers/adminReducers';
import alertReducers from './reducers/alertReducers';
import { taskReducers } from './reducers/taskReducers';
import clientConfigReducers from './reducers/clientConfigReducers';
import setAuthToken from './utils/setAuthToken';
import threeDFusionReducer from './reducers/3dFusionReducer';


const reducer = combineReducers({
  auth: authReducers,
  healthDashboard: healthDashboardReducer,
  safetyDashboard: safetyDashboardReducer,
  performanceDashboard: performanceDashboardReducer,
  securityDashboard: securityDashboardReducer,
  dashboard: dashboardReducer,
  health: healthReducers,
  outdoor:outdoorReducers,
  performance: performanceReducers,
  security: securityReducers,
  project: ProjectReducer,
  building: BuildingReducer,
  floor: FloorReducer,
  dark: modeReducer,
  admin: adminReducers,
  alerts: alertReducers,
  tasks: taskReducers,
  clientConfig: clientConfigReducers,
  threeDFusion: threeDFusionReducer,
});
const format = (storage) => {
  let val = null;
  Object.keys(storage).forEach(function (key) {
    if (JSON.parse(storage.getItem(key)).name !== undefined) {
      val = {
        name: JSON.parse(storage.getItem(key)).name,
        username: JSON.parse(storage.getItem(key)).username,
      };
    }
  });
  return val;
};

const initialState = {
  auth: {},
  dark: {
    loading: false,
    data:
      localStorage.getItem('dark') === null
        ? true
        : JSON.parse(localStorage.getItem('dark')),
  },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware)),
);
// set up a store subscription listener
// to store the users token in localStorage

// initialize current state from redux store for subscription comparison
// preventing undefined error
let currentState = store.getState();

store.subscribe(() => {
  // keep track of the previous and current state to compare changes
  let previousState = currentState;
  currentState = store.getState();
  // if the token changes set the value in localStorage and axios headers
  if (previousState.auth.token !== currentState.auth.token) {
    const token = currentState.auth.token;
    setAuthToken(token);
  }
});

export default store;
